import { Box, HStack, Modal, Pressable, Text } from 'native-base';
import Loading from '../../Common/components/Loading';
import React from 'react';
import { useMHRDocumentListModal } from '../hooks/useMHRDocumentListModal';
import { View } from 'react-native';
import { useTimezones } from '../../Common/hooks/useTimezones';

interface IDoctorMHRDocumentListViewProps {
  customerID: string;
  onDocumentSelect: (documentID: string | null | undefined, repositoryID?: string | null | undefined) => void;
}

export function DoctorMHRDocumentListView({ customerID, onDocumentSelect }: IDoctorMHRDocumentListViewProps) {
  const { loading, error, ok, result } = useMHRDocumentListModal(customerID);

  const { convertUTCDateToUserISO } = useTimezones();

  const setSelectedDocument = (documentID: string | null | undefined, repositoryID?: string | null | undefined) => {
    if (documentID && repositoryID && onDocumentSelect) {
      onDocumentSelect(documentID, repositoryID);
    }
  }

  return (
    <Modal.Content>
      <Modal.CloseButton />
      <Modal.Header>MHR Document List</Modal.Header>

      <Modal.Body h={620}>
        {loading && <Loading />}

        {!loading && !ok && <Text>{error}</Text>}

        {ok && (
          <>
            {result && result?.length > 0 && <>
              <HStack bg={'gray.100'}>
                <Text fontWeight={600} flex={1} p={1}>
                  Date
                </Text>

                <Text fontWeight={600} fontSize={'sm'} flex={2} p={1}>
                  Name
                </Text>

                <Text fontWeight={600} fontSize={'sm'} flex={2} p={1}>
                  Organisation
                </Text>

                <Text fontWeight={600} flex={1} p={1}>
                  Org Type
                </Text>
              </HStack>

              <View style={{ overflow: 'scroll', height: "100%" }}>
                {result?.map((documentItem) => (
                  <Pressable
                    key={documentItem?.documentId}
                    mb={1}
                    pb={1}
                    onPress={() => setSelectedDocument(documentItem?.documentId, documentItem?.repositoryUniqueId)}
                    borderBottomColor={'gray.200'}
                    borderBottomWidth={1}
                  >
                    <HStack alignItems={'center'}>
                      <Text fontWeight={600} flex={1} p={1}>
                        {convertUTCDateToUserISO(documentItem?.creationDate)?.format('DD/MM/YYYY HH:mm')}
                      </Text>

                      <Text flex={2} p={1} fontWeight={500}>
                        {documentItem?.name}
                      </Text>

                      <Text flex={2} p={1} fontWeight={500}>
                        {documentItem?.organization}
                      </Text>

                      <Text flex={1} p={1} fontWeight={500}>
                        {documentItem?.organizationType}
                      </Text>
                    </HStack>
                  </Pressable>
                ))}

                {loading && <Loading />}
              </View>
            </>}
            {!loading && (!result || !result?.length) && <Box h={600} flex={1}>
              <Text>No Documents Available</Text>
            </Box>}
          </>
        )}
      </Modal.Body>
    </Modal.Content>
  );
}